// extracted by mini-css-extract-plugin
module.exports = {"nextPieceGrid":"NextPiece_nextPieceGrid__csATf","color":"NextPiece_color__s1_Bq"};